import Preloader from '@/utils/preloader';

const assets = require.context(
    "../assets",  // context folder
    true,         // include subdirectories
    /.*/,         // RegExp
);

function getAsset(name:string){

    try {
        return assets('./' + name);

    } catch (e){
        console.error("Not found asset " + name );
        return null;
    }

}


export default class Image {

    static current_id = 0;

    id: string;
    assets: string[] = [];
    url: string;
    url_prev: string|null = null;
    zoom: boolean = false;
    used: boolean = false;

    constructor(url: string, url_prev: string|null = null){
        
        this.id = `img-${++Image.current_id}`;

        this.url = getAsset(url);
        this.assets.push(url);

        if(url_prev){
            this.url_prev = getAsset(url_prev);
            this.assets.push(url_prev);
            this.zoom = true;
        }

    }

    async preload(){

        const waits = this.assets.map(a => Preloader.preload(a));
        await Promise.all(waits);

    }

}